import { z } from "zod";

/// DisplayType variants for a DISPLAY_TEXT (type 16) field.
export enum DisplayTextDisplayTypeEnum {
    /// Vertical info - ParameterText = label, ParameterValue = value.
    VERTICAL_INFO = 1,
    /// Horizontal info - ParameterText = label, ParameterValue = value.
    HORIZONTAL_INFO = 2,
    /// Info block heading - uses ParameterValue (falls back to ParameterText if empty).
    INFO_BLOCK_HEADING = 3,
}

export const DisplayTextDisplayTypeEnumSchema = z.nativeEnum(DisplayTextDisplayTypeEnum);
